$(document).ready(function(){
  setInterval(swtaches,1000); 
});

function swtaches() {
   $('.product-item-loop').each(function(){
     if(!$(this).hasClass('Done')){
        var ProductMetaTitleNoColor = $(this).find('.product-item__title').text().split(' - ')[0].replace(/\s/g, '').replace("'", '').replace("-", '').replace('&','-').replace(".", '').replace("(", '').replace(")", '');
        var vendor = $(this).find('.product-meta__vendor').attr("href").split("/").pop().replaceAll('&','-').replaceAll('-', ' ').replaceAll(/(^\w|\s\w)/g, m => m.toUpperCase()).replaceAll(" ", "");
        var vendor2 =$(this).find('.product-meta__vendor').attr("href").split("/").pop();
        var ProductMetaTitleTag = "ProductGroup:" + ProductMetaTitleNoColor;

        var replace = vendor2.replaceAll('&','-').replaceAll('-','');
        var re = new RegExp(replace,"gi");
        ProductMetaTitleTag = ProductMetaTitleTag.replace(re,'');

        var settings_first = {
          "url": "https://workwearhub.com.au/api/2020-01/graphql.json",
          "method": "POST",
          "timeout": 0,
          "headers": {
            "X-Shopify-Storefront-Access-Token": "1d89833ec6d4ba3014407b58644b4716",
            "Authorization": "Basic ODBmOTg5YWRiMDMyMTY1ZWVkYWIwN2Y2ZTNmMjhiZmI6MDVkYzJjMTQwOWJiZmU0ZTk0MDc2YzM4YmJlYTFhODc=",
            "Content-Type": "application/json",
            "Cookie": "__cfduid=dacbe258d4f5d099787913543522794be1597718597; request_method=POST"
          },
          "data": JSON.stringify({
            query: "{shop{primaryDomain{url}}products(first: 15, query:\"tag:'" + ProductMetaTitleTag + "'\" ) {edges {node { id title tags onlineStoreUrl handle images(first:1){edges{node{originalSrc}}}}}}}",
            //query: "{products(first:250){edges {node { title }}}}",
            variables: {}
          })};

        var element = this;  

        $.ajax(settings_first).done(function (response) {
          
          var shopUrl = response.data.shop.primaryDomain.url;
          var arrayResponse = response.data.products.edges;
          let items = arrayResponse.map(element => (element));
          let arrayImgs = items.map(element => element.node.images.edges);
          let arrayTitles = items.map(element => element.node.title.toLowerCase().split(' - ')[1].split('/'));
          let arrayHandles = items.map(element => shopUrl + "/products/" + element.node.handle);
          let arrayImgsSrc = arrayImgs.map(element => element[0].node.originalSrc);

          let arrayItem = arrayImgsSrc.map((imageSrc, i) => ({
            imageSrc,
            productURL: arrayHandles[i],
            color: arrayTitles[i]
          }));

          $(element).find('#myItemList').html('<div></div>');
          $(element).find('#myItemList').find('div').html('<ul></ul>');
          var infoHTML = "";
          
          arrayItem.forEach(function (item) { 
           
          //  let isCurrentProduct = ProductTypeColor === item.color.toString().replace(',', '/').replace(' ', '-');
            let arrayColors = [];
            if (item.color.length > 1) {
               item.color.forEach((item) => {
                 item = item.replace(/\s/g, '-');
                var primaryColorClass = "color-" + item;
                $(element).find('#myItemList div').addClass(primaryColorClass);
                
                var bg =   $(element).find('#myItemList .'+primaryColorClass).css('background-color');
                
                arrayColors.push(bg);
                $(element).find('#myItemList div').removeClass(primaryColorClass)   

              });

              let stringLinearGradient = "";
              arrayColors.forEach((color, i) => {
              const partOfTotal = 100 / (arrayColors.length + 1);
              stringLinearGradient += `${color} ${i * partOfTotal + partOfTotal}%${i===arrayColors.length - 1 ? '' : ', '}`
              })
             
              linearcolor = `background: linear-gradient(135deg, ${stringLinearGradient});`;
             
              if (window.location.href.indexOf("work-wear-hub-staging.myshopify.com") > -1) {
                var string = item.productURL;
                var new_string = string.replace('https://www.workwearhub.com.au/','https://work-wear-hub-staging.myshopify.com/');
              }else{
                var new_string = item.productURL;
              }

              str = '';
             infoHTML +=  '<li><a href="'+new_string+'"><span class="other-products-span-color" style="'+linearcolor+'"></span></a></li>';
              
              
            } else {
              
              if (window.location.href.indexOf("work-wear-hub-staging.myshopify.com") > -1) {
              var string = item.productURL;
              var new_string = string.replace('https://www.workwearhub.com.au/','https://work-wear-hub-staging.myshopify.com/');
              }else{
              var new_string = item.productURL;
              }

            
           
               text = item.color[0].replace(" ","-");
             

              str = item.color[0].replace(/\s+/g, '-').toLowerCase();

              infoHTML +=  '<li><a href="'+new_string+'"><span class="other-products-span-color color-' + str + '"></span></a></li>';
              
            //  $(element).find('#myItemList div ul').append('<li><a href="'+new_string+'"><span class="other-products-span-color color-' + item.color[0] + '"></span></a></li>');

            }
          });

      

          var arr = infoHTML.split('<li>');
        
          var remaining = arr.length - 7;
          
          if(arr.length <= 7){
             //$(element).find('#myItemList div ul').append(arr.length - 1);
             $(element).find('#myItemList div ul').append(infoHTML);}
          else{
              $(element).find('#myItemList div ul').addClass('hide-UL-element');
              for(var i=0;i<=6;i++){
                if(arr[i] != ''){
                  $(element).find('#myItemList div ul').append('<li>'+arr[i]+'</li>');
                }
              }
            
              $(element).find('#myItemList div ul.hide-UL-element').append('<li><span class="show-more-swatch">+'+remaining+'</span></li>')
              $(element).find('#myItemList div ul.hide-UL-element').after('<ul class="show-UL-element"></ul>');
              for(var i=0;i<arr.length;i++){
                  $(element).find('#myItemList div ul.show-UL-element').append('<li>'+arr[i]+'</li>');
              }
              $(element).find('#myItemList div ul.show-UL-element').append('<li><span class="show-less-swatch"></span></li>')}
        });

     $(this).addClass('Done');
     }
});

  // -- Algolia Search -- //
   var ck_vendor = 1;
$('li.ais-Hits-item').each(function(){
  if(!$(this).hasClass('Done')){
     var ProductMetaTitleNoColor = $(this).find('.ais-hit--title a').attr('title').split(' - ')[0].replace(/\s/g, '').replace("'", '').replace("-", '').replace('&','-').replace(".", '').replace("(", '').replace(")", '');
     var vendor = $(this).find('.product-meta__vendor').attr("href").split("/").pop().replaceAll('&','-').replaceAll('-', ' ').replaceAll(/(^\w|\s\w)/g, m => m.toUpperCase()).replaceAll(" ", "");
     var vendor2 =$(this).find('.product-meta__vendor').attr("href").split("/").pop();
     var ProductMetaTitleTag = "ProductGroup:" + ProductMetaTitleNoColor;

     var replace = vendor2.replaceAll('&','-').replaceAll('-','');
     var re = new RegExp(replace,"gi");
     ProductMetaTitleTag = ProductMetaTitleTag.replace(re,'');

     var settings_first = {
       "url": "https://workwearhub.com.au/api/2020-01/graphql.json",
       "method": "POST",
       "timeout": 0,
       "headers": {
         "X-Shopify-Storefront-Access-Token": "1d89833ec6d4ba3014407b58644b4716",
         "Authorization": "Basic ODBmOTg5YWRiMDMyMTY1ZWVkYWIwN2Y2ZTNmMjhiZmI6MDVkYzJjMTQwOWJiZmU0ZTk0MDc2YzM4YmJlYTFhODc=",
         "Content-Type": "application/json",
         "Cookie": "__cfduid=dacbe258d4f5d099787913543522794be1597718597; request_method=POST"
       },
       "data": JSON.stringify({
         query: "{shop{primaryDomain{url}}products(first: 15, query:\"tag:'" + ProductMetaTitleTag + "'\" ) {edges {node { id title tags onlineStoreUrl handle images(first:1){edges{node{originalSrc}}}}}}}",
         //query: "{products(first:250){edges {node { title }}}}",
         variables: {}
       })};

     var element = this;  

     $.ajax(settings_first).done(function (response) {
       
       var shopUrl = response.data.shop.primaryDomain.url;
       var arrayResponse = response.data.products.edges;
       let items = arrayResponse.map(element => (element));
       let arrayImgs = items.map(element => element.node.images.edges);
       let arrayTitles = items.map(element => element.node.title.toLowerCase().split(' - ')[1].split('/'));
       let arrayHandles = items.map(element => shopUrl + "/products/" + element.node.handle);
       let arrayImgsSrc = arrayImgs.map(element => element[0].node.originalSrc);

       let arrayItem = arrayImgsSrc.map((imageSrc, i) => ({
         imageSrc,
         productURL: arrayHandles[i],
         color: arrayTitles[i]
       }));

       $(element).find('#myItemList').html('<div></div>');
       $(element).find('#myItemList').find('div').html('<ul></ul>');
       var infoHTML = "";
       
       arrayItem.forEach(function (item) { 
        
       //  let isCurrentProduct = ProductTypeColor === item.color.toString().replace(',', '/').replace(' ', '-');
         let arrayColors = [];
         if (item.color.length > 1) {
            item.color.forEach((item) => {
              item = item.replace(/\s/g, '-');
             var primaryColorClass = "color-" + item;
             $(element).find('#myItemList div').addClass(primaryColorClass);
             
             var bg =   $(element).find('#myItemList .'+primaryColorClass).css('background-color');
             
             arrayColors.push(bg);
             $(element).find('#myItemList div').removeClass(primaryColorClass)   

           });

           let stringLinearGradient = "";
           arrayColors.forEach((color, i) => {
           const partOfTotal = 100 / (arrayColors.length + 1);
           stringLinearGradient += `${color} ${i * partOfTotal + partOfTotal}%${i===arrayColors.length - 1 ? '' : ', '}`
           })
          
           linearcolor = `background: linear-gradient(135deg, ${stringLinearGradient});`;
          
           if (window.location.href.indexOf("work-wear-hub-staging.myshopify.com") > -1) {
             var string = item.productURL;
             var new_string = string.replace('https://www.workwearhub.com.au/','https://work-wear-hub-staging.myshopify.com/');
           }else{
             var new_string = item.productURL;
           }

           str = '';
          infoHTML +=  '<li><a href="'+new_string+'"><span class="other-products-span-color" style="'+linearcolor+'"></span></a></li>';
           
           
         } else {
           
           if (window.location.href.indexOf("work-wear-hub-staging.myshopify.com") > -1) {
           var string = item.productURL;
           var new_string = string.replace('https://www.workwearhub.com.au/','https://work-wear-hub-staging.myshopify.com/');
           }else{
           var new_string = item.productURL;
           }

         
        
            text = item.color[0].replace(" ","-");
          

           str = item.color[0].replace(/\s+/g, '-').toLowerCase();

           infoHTML +=  '<li><a href="'+new_string+'"><span class="other-products-span-color color-' + str + '"></span></a></li>';
           
         //  $(element).find('#myItemList div ul').append('<li><a href="'+new_string+'"><span class="other-products-span-color color-' + item.color[0] + '"></span></a></li>');

         }
       });

   

       var arr = infoHTML.split('<li>');
     
       var remaining = arr.length - 7;
       
       if(arr.length <= 7){
          //$(element).find('#myItemList div ul').append(arr.length - 1);
          $(element).find('#myItemList div ul').append(infoHTML);}
       else{
           $(element).find('#myItemList div ul').addClass('hide-UL-element');
           for(var i=0;i<=6;i++){
             if(arr[i] != ''){
               $(element).find('#myItemList div ul').append('<li>'+arr[i]+'</li>');
             }
           }
         
           $(element).find('#myItemList div ul.hide-UL-element').append('<li><span class="show-more-swatch">+'+remaining+'</span></li>')
           $(element).find('#myItemList div ul.hide-UL-element').after('<ul class="show-UL-element"></ul>');
           for(var i=0;i<arr.length;i++){
               $(element).find('#myItemList div ul.show-UL-element').append('<li>'+arr[i]+'</li>');
           }
           $(element).find('#myItemList div ul.show-UL-element').append('<li><span class="show-less-swatch"></span></li>')}
     });

  $(this).addClass('Done');
          //render again vendor logo
    if(ck_vendor == 1){
         replace_vendor_logo();show_vendor();
      console.log(' ck_vendor');
    }
     ck_vendor++;
     console.log(' load again');
  }
})
}

